import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-right",
  "use": "arrow-down-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-down-right\">\n<path d=\"M17,18c-0.3,0-0.5-0.1-0.7-0.3l-10-10c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l10,10c0.4,0.4,0.4,1,0,1.4C17.5,17.9,17.3,18,17,18\n\tz\" />\n<path d=\"M17,18H7c-0.6,0-1-0.4-1-1s0.4-1,1-1h9V7c0-0.6,0.4-1,1-1s1,0.4,1,1v10C18,17.6,17.6,18,17,18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol